import n from '../../../../../../../external/rollup-plugin-styles/dist/runtime/inject-css.js';
var css = ".monaco-editor .lines-content .core-guide{box-sizing:border-box;height:100%;position:absolute}";
n(css,{});
export { css, css as default };
